import React, { useContext } from 'react';
import {
  CiterightContext,
  CiterightContextProvider,
  useUrlParam,
} from './CiterightContextProvider';
import { LandingScreen } from './components/LandingScreen';
import { SimpleResultsView } from './components/SimpleResultsView';
import { EvaluationPage } from './EvaluationPage';
import { useNoClaimsToast } from './hooks/useNoClaimsToast';
import { useTabVisibilityMilestones } from './hooks/useTabVisibilityMilestones';
import { ImpressionWatcher } from 'js/utils/impressions/ImpressionWatcher';

const CiterightSimpleContent: React.FC = () => {
  const context = useContext(CiterightContext);
  // Read claim_id from URL for evaluation page routing
  const { value: claimId } = useUrlParam('claim_id');
  const reportId = context?.reportId;

  // Show toast with "New Analysis" button when analysis completes with no claims found
  useNoClaimsToast({ withButton: true });

  useTabVisibilityMilestones(reportId ?? null);

  // If claim_id is present, show evaluation page for source comparison
  if (claimId) {
    return <EvaluationPage claimId={claimId} />;
  }

  // Show landing screen if no report_id, otherwise show results
  return reportId ? <SimpleResultsView /> : <LandingScreen />;
};

export const CiterightSimple: React.FC = () => {
  return (
    <CiterightContextProvider>
      <ImpressionWatcher source="citeright.simple">
        <div style={{ minHeight: '100vh' }}>
          <CiterightSimpleContent />
        </div>
      </ImpressionWatcher>
    </CiterightContextProvider>
  );
};

export default CiterightSimple;
